<mapfre-card [singleCard]="false" [additionalClasses]="'dashboard-policies policy-renewal'" *ngIf="expiringPolicyArray?.length > 0 && containLivoPolicy">
  <div class="row">
    <div class="policy-background policybgTop">
      <svg-policy-svg></svg-policy-svg>
    </div>
    <div class="policy-content col">
      <h2 class="policyHeadTop">
        <div class="col-12 title no-padding">
          {{'YOUR_RENEWAL_INFORMATION' | translate}}
        </div> 
      </h2> 
      <div class="col sub_head">
        {{'RENEWAL_TEXT_ONE' | translate}} <span class="blue-text font-bold"><a routerLink="/contact">{{'RENEWAL_INFO_CONTACT_YOUR_AGENT' | translate}}</a></span>
      </div>
      <div class="col sub_head">
        {{'RENEWAL_TEXT_THREE' | translate}}
       </div> 
     
      <div class="row renPolicy" *ngFor="let policy of expiringPolicyArray" [ngClass]="{'policy-row':policy?.livoPolicy}" > 
        <ng-container *ngIf="policy?.livoPolicy">
          <div class="col-12 col-md-6">
              <div  class="d-flex align-items-center renewIcon" >
                <div class="policy-icon policy-icon-top float-left margin-right mr8 auto-svg">
                  <span *ngIf="policy.policyType === 'AUTO' || policy.policyType === 'COMMERCIAL_AUTO'">
                    <ng-container *ngIf="isAcmic; else nonAcmicCarIcon">
                      <img src="assets/img/images/icon-car-24.svg"  alt="car icon" />
                    </ng-container>
                    <ng-template #nonAcmicCarIcon>
                      <svg-car-mono-color-small-svg></svg-car-mono-color-small-svg>
                    </ng-template>
                  </span>
                  <span *ngIf="policy.policyType === 'HOME'">
                    <ng-container *ngIf="isAcmic; else nonAcmicHomeIcon">
                      <img src="assets/img/images/icon-home-24.svg"  alt="home icon" />
                    </ng-container>
                    <ng-template #nonAcmicHomeIcon>
                      <svg-house-mono-color-small-svg></svg-house-mono-color-small-svg>
                    </ng-template>
                  </span>
                  <span *ngIf="policy.policyType === 'UMBRELLA'">
                    <ng-container *ngIf="isAcmic; else nonAcmicUmbrellaIcon">
                      <img src="assets/img/images/icon-umbrella-acmic.svg"  alt="umbrella icon" />
                    </ng-container>
                    <ng-template #nonAcmicUmbrellaIcon>
                      <svg-umbrella-svg></svg-umbrella-svg>
                    </ng-template>
                  </span>
                  <span *ngIf="policy.policyType === 'SCHEDULED_PROPERTY'"><svg-property-svg></svg-property-svg></span>
                  <span *ngIf="policy.policyType === 'DWELLING_FIRE_PERSONAL' || policy.policyType === 'COMMERCIAL_FIRE'"><svg-dwelling-fire-svg></svg-dwelling-fire-svg></span>
                  <span *ngIf="policy.policyType === 'GARAGE_KEEPER'"><svg-garage-svg></svg-garage-svg></span>
                  <span *ngIf="policy.policyType === 'GENERAL_LIABILITY' || policy.policyType === 'SPECIAL_MULTI_PERIL'"><svg-liability-svg></svg-liability-svg></span>
                </div>
                <div class="policy-info">
                  <div class="policy-info-contents">
                    {{'CURRENT_NUMBER' | translate}} :
                  </div>
                </div>
                <div class="policyNumberBold"> <b>{{policy?.policynumber.policyNumber}}</b></div>
              </div>
          </div>
          <div class="col-12 col-md-6 text-md-center
          ">
            <div class="label_text">
              <span>{{'NEW' | translate}}</span>
            </div>
            <div class="bold_green bold-17 mr-md-3">
                <span>{{policy?.livoPolicy}}</span>
            </div>
          
            <div class="col-4 col-md-auto float-md-none float-right no-padding" >
                <mapfre-link [additionalClasses]="'ghost blue primary medium-btn no-margin btn btnViewRenw'"
                (click)="redirectToNewGWPolicy(policy?.livoPolicy)">
                  {{ 'VIEW' | translate}}
                </mapfre-link>
            </div>
            
          </div>
          <div class="col-3 text-center"></div>
        </ng-container>

      </div>
      <div class="margin-vertical mv24 info-icon1 col-12 pl-3 pl-md-0"  *ngIf="policy21Flag">
          <mapfre-info-divs>
            <em>
              {{ 'PROCESSING_BILLING_BALANCE_1' | translate }} 
                <strong>{{policyWith21DaysStr}}.</strong>
              {{'PROCESSING_BILLING_BALANCE_2' | translate}}
            </em> 
          </mapfre-info-divs>
        </div>
      
        <div class="margin-vertical mv24 info-icon col-12 pl-3 pl-md-0 mar-top-50"  *ngIf="policyFlag">
          <mapfre-info-divs>
            <em>
              {{ policyBetween20And0Str.includes('and') ? ('PRIOR_RENEWAL_BALANCE_SYNC_PLURAL_1' | translate) : ('PRIOR_RENEWAL_BALANCE_SYNC_1' | translate) }}
               <strong>{{policyBetween20And0Str}}.</strong>  
              {{'PRIOR_RENEWAL_BALANCE_SYNC_2' | translate}}
            </em> 
          </mapfre-info-divs>
        </div>
    </div>
  </div>
  <div class="clear-fix"></div>
</mapfre-card>